import React, {useCallback, useEffect, useState} from "react";
import PieChartHook from "./PieChartHook";
import {getCategoryCompositionGraph, getGradeCompositionGraph} from "../../../apihelper/portfolio";
import {Autocomplete, CircularProgress, TextField, useMediaQuery} from "@mui/material";
import json2mq from "json2mq";

const CompositionChart = (props = {}) => {
    const {portfolioId} = props;
    const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
    const [categoryGraphData, setCategoryGraphData] = useState();
    const [gradeGraphData, setGradeGraphData] = useState();
    const [portfolio_id, setportfolio_id] = useState();
    const [gradeColor, setGradeColor] = useState([]);
    const mediaQueryVar = useMediaQuery(
            json2mq({
                minWidth: 900,
            })
        );
    React.useEffect(() => {
        setportfolio_id(portfolioId);
    }, [portfolioId]);

    const fetchCategoryData = useCallback(() => {
        if (!userData && portfolio_id) {
            return;
        }
        getCategoryCompositionGraph(portfolio_id, userData)
        .then((res) => {
            setCategoryGraphData(processApiData(res));
        })
        .catch((error) => {
            console.error("Fetch data error:", error);
        });
    }, [portfolio_id]);

    useEffect(() => {
        if (userData) {
            fetchCategoryData();
        }
    }, [fetchCategoryData]);


    const fetchGradeData = useCallback(() => {
        if (!userData && portfolio_id) {
            return;
        }
        getGradeCompositionGraph(portfolio_id, userData)
        .then((res) => {
            const processedData = processApiData(res);
            const backgroundColors = [];
            for (let i = 0; i < processedData.labels.length; i++) {
                const label = processedData.labels[i];

                if (label === 'Outperformer') {
                    backgroundColors.push('green');
                } else if (label === 'Underperformer') {
                    backgroundColors.push('red');
                } else if (label === 'Moderate Performer') {
                    backgroundColors.push('#FFBF00');
                } else {
                    backgroundColors.push('gray'); // default/fallback
                }
            }
            setGradeGraphData(processedData);
            setGradeColor(backgroundColors);
        })
        .catch((error) => {
            console.error("Fetch data error:", error);
        });
    }, [portfolio_id]);

    useEffect(() => {
        if (userData) {
            fetchGradeData();
        }
    }, [fetchGradeData]);

    const processApiData = (data) => {
        const totalPortfolioValue = data.total_portfolio_value_calculated;
        const categoryData = data.data;

        const chartData = {
            data: [],
            labels: [],
        };
        categoryData.forEach((category) => {
            const categoryValuePercentage = (category.total_price * 100) / totalPortfolioValue;
            if (categoryValuePercentage >= 1) {
                chartData.data.push(parseFloat(categoryValuePercentage.toFixed(2)));
                chartData.labels.push(category.key);
            }
        });
        return chartData;
    };

    return (
        <div className="d-md-flex justify-content-md-between pie-chart-main" style={{marginRight: mediaQueryVar?"25px":""}}>
            <div
                style={{
                    width: "400px",
                    height: "400px",
                    margin: "0px",
                    padding: "0px",
                    marginTop:"10px",
                    paddingTop:"10px",
                    paddingLeft:"5px",
                    paddingRight:"5px"
                }}
                className="line-graph"
            >
                {categoryGraphData && (
                    <PieChartHook
                        graphData={categoryGraphData}
                        headingText={"CATEGORY COMPOSITION"}
                        style={{
                            width: "400px",
                            height: "300px",
                            margin: "0px",
                        }}
                    />
                )}
            </div>
            <div
                style={{
                    width: "400px",
                    height: "400px",
                    margin: "0px",
                    padding: "0px",
                    marginTop:"10px",
                    paddingTop:"10px",
                    paddingLeft:"5px",
                    paddingRight:"5px"
                }}
                className="line-graph"
            >
                {gradeGraphData && (
                    <PieChartHook
                        graphData={gradeGraphData}
                        headingText={"GRADE COMPOSITION"}
                        style={{
                            width: "400px",
                            height: "300px",
                            margin: "0px",
                        }}
                        backgroundColor={gradeColor}
                    />
                )}
            </div>
        </div>
    );
};

export default CompositionChart;
